var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 3.33333L2.3562 4.04047L0 7.95953L2 12L0 16.0405L2.3562 19.9595L6.66667 20.6667L9.6438 24H14.3562L17.3333 20.6667L21.6438 19.9595L24 16.0405L22 12L24 7.95953L21.6438 4.04047L17.3333 3.33333L14.3562 0H9.6438L6.66667 3.33333ZM10.4112 1.71429L7.54182 4.92696L3.41661 5.60371L1.95229 8.0393L3.91281 12L1.95229 15.9607L3.41661 18.3963L7.54182 19.073L10.4112 22.2857H13.5888L16.4582 19.073L20.5834 18.3963L22.0477 15.9607L20.0872 12L22.0477 8.0393L20.5834 5.60371L16.4582 4.92696L13.5888 1.71429H10.4112Z",
    fill: "#BCB3D0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.4286C13.8935 15.4286 15.4286 13.8935 15.4286 12C15.4286 10.1065 13.8935 8.57143 12 8.57143C10.1065 8.57143 8.57143 10.1065 8.57143 12C8.57143 13.8935 10.1065 15.4286 12 15.4286ZM12 17.1429C14.8403 17.1429 17.1429 14.8403 17.1429 12C17.1429 9.15968 14.8403 6.85714 12 6.85714C9.15968 6.85714 6.85714 9.15968 6.85714 12C6.85714 14.8403 9.15968 17.1429 12 17.1429Z",
    fill: "#BCB3D0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ca44d457bd642ceec8c6365e4febcd0a.svg";
export { ForwardRef as ReactComponent };